<p-dialog [(visible)]="displaySelectedVideo"
          [blockScroll]="true"
          [header]="selectedVideo?.title"
          [modal]="true"
          class="video-dialog"
          [draggable]="false"
          [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}"
>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="iframe-container">
                <iframe class="responsive-iframe" loading="lazy" allowfullscreen="true" width="100%" height="550"
                        [src]="selectedVideoLink"
                        frameborder="0"></iframe>
            </div>
        </div>
    </div>
</p-dialog>


<div class="p-mt-4">
    <div class="card p-shadow-4">
        <!--Header-->
        <div class="p-grid divider-bottom p-ai-center p-mb-0">
            <!--Heading Title-->
            <div class="p-col-12">
                <h5 class="p-mb-1 p-text-primary">
                    Training
                </h5>
                <div class="p-text-secondary p-pt-1" style="font-size: 1.6vmin">We're glad you're here! Watch this
                    section for training videos for more details.
                </div>
            </div>
        </div>


        <div class="p-grid p-jc-center p-mt-4">
            <div class="p-col-12 p-xl-8">

                <ul class="list-group">
                    <li (click)="openAndPlayVideo(video)" class="p-cursor list-group-item list-group-item-info"
                        *ngFor="let video of videoModel">
                        <div class="p-d-flex p-ai-center">
                            <div class="p-mr-2 p-mt-1">
                                <i class="pi pi-video" style="font-size: 1.25rem"></i>
                            </div>
                            <div>
                                <a style="font-size: 1.25rem;" target="_blank"> {{video?.title}} </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
